<template>
  <div>
    <FireWork
      v-if="bannerPlaceHolderForFireWorkStoryBlock &&
      bannerPlaceHolderForFireWorkStoryBlock.tag_text && widgetType &&
      bannerPlaceHolderForFireWorkStoryBlock.tag_text.toLowerCase() === widgetType.toLowerCase()"
    />
    <FireWork
      v-if="bannerPlaceHolderForFireWorkGrid &&
      bannerPlaceHolderForFireWorkGrid.tag_text && widgetType &&
      bannerPlaceHolderForFireWorkGrid.tag_text.toLowerCase() === widgetType.toLowerCase()"
      fireWorkType='gridFeed'
    />
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['widgetType', 'bannerPlaceHolderForFireWorkStoryBlock', 'bannerPlaceHolderForFireWorkGrid'],
  components: {
    FireWork: () => import(/* webpackPrefetch: true */ './common/FireWork')
  }
}
</script>



// WEBPACK FOOTER //
// HomeWidgetsWrapper.vue?6e11a79b